module.exports = "/_next/static/images/8ae6cffe4984f0db600bc5e39053e323-credit-card-magic.png.webp";